export enum FidelityProgramEventName {
  PRINT_PRESCRIPTION = 'PRINT_PRESCRIPTION',
  DOWNLOAD_PRESCRIPTION = 'DOWNLOAD_PRESCRIPTION',
  DOWNLOAD_MATERIAL = 'DOWNLOAD_MATERIAL',
  PARTICIPATION_IN_EVENT = 'PARTICIPATION_IN_EVENT',
  WATCH_VIDEO = 'WATCH_VIDEO',
  COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION'
}

export enum FidelityProgramEventSource {
  FRONT_END = 'FRONT_END',
  BACK_END = 'BACK_END'
}

interface IFidelityProgramEventBaseModel {
  eventName: FidelityProgramEventName;
  page: string;
  timestamp: string;
  source: FidelityProgramEventSource;
  metadata?: string;
  isDeleted: boolean;
  idVet: number;
}

export interface IFidelityProgramEventModel
  extends IFidelityProgramEventBaseModel {
  idPet?: number;
  idTutor?: number;
  idOrientation?: number;
  idMaterial?: number;
  idEvent?: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ISendingFidelityProgramEventModel
  extends Omit<
    IFidelityProgramEventModel,
    'timestamp' | 'isDeleted' | 'source'
  > {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ISendingFidelityProgramEventBaseModel
  extends Omit<
    IFidelityProgramEventBaseModel,
    'eventName' | 'timestamp' | 'isDeleted' | 'source' | 'page'
  > {}

export interface IVetPrintPrescriptionEventModel
  extends ISendingFidelityProgramEventBaseModel {
  idOrientation: number;
  idPet: number;
}

export interface ITutorPrintPrescriptionEventModel
  extends ISendingFidelityProgramEventBaseModel {
  idTutor: number;
  idOrientation: number;
  idPet: number;
}

export interface IVetDownloadPrescriptionEventModel
  extends ISendingFidelityProgramEventBaseModel {
  idOrientation: number;
  idPet: number;
  idTutor: number;
}

export interface ITutorDownloadPrescriptionEventModel
  extends ISendingFidelityProgramEventBaseModel {
  idTutor: number;
  idOrientation: number;
  idPet: number;
}

export interface IVetDownloadMaterialEventModel
  extends ISendingFidelityProgramEventBaseModel {
  idMaterial: number;
}

export interface ITutorDownloadMaterialEventModel
  extends ISendingFidelityProgramEventBaseModel {
  idTutor: number;
  idMaterial: number;
}

export interface IParticipationInEventEventModel
  extends ISendingFidelityProgramEventBaseModel {
  idEvent: string;
}

export interface IWatchVideoEventModel
  extends ISendingFidelityProgramEventBaseModel {
  idEvent: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICompleteRegistrationEventModel
  extends ISendingFidelityProgramEventBaseModel {}
